'use client';

import React, { type Dispatch, type SetStateAction, useMemo, useState } from 'react';

import { CssBaseline, GlobalStyles, ThemeProvider } from '@unity/cloud-ui';
import type {} from '@unity/cloud-ui/themeCssVarsAugmentation';

import { ThemeContext, type ThemeZoom } from './theme-context';
import themeConstants from './theme-constants';
import { customPalette } from './custom-palette';

const themeOverrides = [
  themeConstants,
  {
    colorSchemes: {
      light: { palette: customPalette.light },
      dark: { palette: customPalette.dark },
    },
  },
];

export const ThemeRegistry = (props: React.PropsWithChildren) => {
  const { children } = props;
  const [zoom, setZoom] = useState<ThemeZoom>('normal');

  const contextValue: {
    zoom: ThemeZoom;
    setZoom: Dispatch<SetStateAction<ThemeZoom>>;
  } = useMemo(() => ({ zoom, setZoom }), [zoom]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <ThemeProvider mode="vars" themeOverrides={themeOverrides} disableTransitionOnChange>
        <CssBaseline enableColorScheme withCloudUIStyling />
        <GlobalStyles
          styles={(theme) => ({
            body: { backgroundColor: theme.vars.palette.background.default },
          })}
        />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
